import { MenuItem } from 'prosemirror-menu'
import { Node, NodeType, Schema } from 'prosemirror-model'
import { schema } from 'prosemirror-schema-basic'
import {
  EditorState,
  NodeSelection,
  Plugin,
  PluginKey
} from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'

import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker'

import { defaultSettings, updateImageNode } from 'prosemirror-image-plugin'
import { I18nService } from '../../../../../providers/i18n/i18n.service'
import { ModalService } from '../../../../../providers/modal/modal.service'
import { AssetPickerDialogComponent } from '../../../asset-picker-dialog/asset-picker-dialog.component'
import { ExternalImageAttrs } from '../../external-image-dialog/external-image-dialog.component'
import { ContextMenuService } from '../context-menu/context-menu.service'
import { canInsert, renderClarityIcon } from '../menu/menu-common'

const imageSettings = { ...defaultSettings }

export const imagePluginKey = new PluginKey('image')

const imageSchema = new Schema({
  nodes: updateImageNode(schema.spec.nodes, {
    ...imageSettings
  }),
  marks: schema.spec.marks
})

export function getImageNodes() {
  return {
    image: {
      inline: true,
      attrs: {
        src: {},
        alt: { default: null },
        title: { default: null }
      },
      group: 'inline',
      draggable: true,
      parseDOM: [
        {
          tag: 'img[src]',
          getAttrs(dom: HTMLElement) {
            return {
              src: dom.getAttribute('src'),
              title: dom.getAttribute('title'),
              alt: dom.getAttribute('alt')
            }
          }
        }
      ],
      toDOM(node: Node) {
        const { src, alt, title } = node.attrs
        return ['img', { src, alt, title }]
      }
    }
  }
}

export function insertImageItem(
  nodeType: NodeType,
  modalService: ModalService,
  i18nService: I18nService
) {
  return new MenuItem({
    title: _('editor.image'),
    label: _('editor.image'),
    render: renderClarityIcon({
      shape: 'image',
      label: i18nService.translate('editor.image')
    }),
    class: '',
    css: '',
    enable(state: EditorState) {
      return canInsert(state, nodeType)
    },
    // run(state: EditorState, dispatch, view: EditorView) {
    // Create a hidden file input to select images
    // const input = document.createElement('input')
    // input.type = 'file'
    // input.accept = 'image/*'
    // input.style.display = 'none'

    // input.onchange = () => {
    //   if (input.files && input.files[0]) {
    //     const file = input.files[0]
    //     const reader = new FileReader()

    //     reader.onload = (e) => {
    //       const src = e.target?.result as string
    //       const imageNode = nodeType.createAndFill({ src, title: file.name })

    //       if (dispatch && imageNode) {
    //         const tr = view.state.tr.replaceSelectionWith(imageNode)
    //         dispatch(tr)
    //       }

    //       view.focus()
    //     }

    //     reader.readAsDataURL(file)
    //   }
    // }

    // // Trigger the file input dialog
    // document.body.appendChild(input)
    // input.click()
    // document.body.removeChild(input)

    // return true
    // }
    run(state: EditorState, _, view: EditorView) {
      let attrs: ExternalImageAttrs | undefined
      if (
        state.selection instanceof NodeSelection &&
        state.selection.node.type === nodeType
      ) {
        attrs = state.selection.node.attrs as ExternalImageAttrs
      }
      modalService
        .fromComponent(AssetPickerDialogComponent, {
          closable: true,
          size: 'xl'
        })
        .subscribe((result) => {
          if (result) {
            console.log(' .subscribe - result:', result)
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            view.dispatch(
              view.state.tr.replaceSelectionWith(
                nodeType.createAndFill(result)!
              )
            )
          }
          view.focus()
        })
    }
  })
}

export const imageContextMenuPlugin = (
  contextMenuService: ContextMenuService,
  modalService: ModalService
) =>
  new Plugin({
    view: () => ({
      update: (view) => {
        if (!view.hasFocus()) {
          return
        }
        const { doc, selection } = view.state
        let imageNode: Node | undefined
        let imageNodePos = 0
        doc.nodesBetween(selection.from, selection.to, (n, pos, parent) => {
          if (n.type.name === 'image') {
            imageNode = n
            imageNodePos = pos
            return false
          }
        })
        if (imageNode) {
          const node = view.nodeDOM(imageNodePos)
          if (node instanceof HTMLImageElement) {
            contextMenuService.setContextMenu({
              ref: selection,
              title: _('editor.image'),
              iconShape: 'image',
              element: node,
              coords: view.coordsAtPos(imageNodePos),
              items: [
                {
                  enabled: true,
                  iconShape: 'image',
                  label: 'Image properties',
                  onClick: () => {
                    contextMenuService.clearContextMenu()
                    modalService
                      .fromComponent(AssetPickerDialogComponent, {
                        closable: true,
                        size: 'xl',
                        locals: {
                          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                          // existing: imageNode!.attrs as ExternalImageAttrs
                        }
                      })
                      .subscribe((result) => {
                        console.log(' .subscribe - result:', result)
                        if (result) {
                          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                          view.dispatch(
                            view.state.tr.replaceSelectionWith(
                              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                              imageNode!.type.createAndFill(result)!
                            )
                          )
                        }
                        view.focus()
                      })
                    //   const input = document.createElement('input')
                    //   input.type = 'file'
                    //   input.accept = 'image/*'
                    //   input.style.display = 'none'

                    //   input.onchange = () => {
                    //     if (input.files && input.files[0]) {
                    //       const file = input.files[0]
                    //       const reader = new FileReader()

                    //       reader.onload = (e) => {
                    //         const src = e.target?.result as string
                    //         const attrs = {
                    //           ...imageNode?.attrs,
                    //           src,
                    //           title: file.name
                    //         }

                    //         const tr = view.state.tr.setNodeMarkup(
                    //           imageNodePos,
                    //           undefined,
                    //           attrs
                    //         )
                    //         view.dispatch(tr)
                    //         view.focus()
                    //       }

                    //       reader.readAsDataURL(file)
                    //     }
                    //   }

                    //   document.body.appendChild(input)
                    //   input.click()
                    //   document.body.removeChild(input)
                  }
                },
                {
                  enabled: true,
                  iconShape: 'trash',
                  label: 'Remove Image',
                  onClick: () => {
                    contextMenuService.clearContextMenu()
                    const tr = view.state.tr.delete(
                      imageNodePos,
                      imageNodePos + imageNode!.nodeSize
                    )
                    view.dispatch(tr)
                    view.focus()
                  }
                }
              ]
            })
          }
        } else {
          contextMenuService.clearContextMenu()
        }
      }
    })
  })
